import ShipmentCalculatedValue from '../../../../components/shipment-calculated-value/shipment-calculated-value'
import {
    getShipmentActualMaterialWidths,
    hasShipmentMaterialConsumptions,
} from '../../../../helpers/entities/shipment/get-shipment-material-consumptions'
import {
    getShipmentDisplayCalculated,
    isShipmentCalculatedOnActual,
} from '../../../../helpers/entities/shipment/get-shipment-display-calculated'
import { onCellStandard } from '../../helpers/helpers'
import { DataSourceItem } from '../../shipments-page'
import type { ShipmentColumn } from '../../types/column-types'

export const calculatedMaterialWidthColumn: ShipmentColumn = {
    key: 'materialWidth',
    dataIndex: ['calculated', 'materialWidth'],
    title: 'Ширина роля',
    width: 62,
    onCell: onCellStandard,
    render: (_v, r: DataSourceItem) => {
        if (hasShipmentMaterialConsumptions(r)) {
            const widths = getShipmentActualMaterialWidths(r)

            return (
                <ShipmentCalculatedValue isActual>
                    {widths.length ? widths.join(', ') : '—'}
                </ShipmentCalculatedValue>
            )
        }

        const width = getShipmentDisplayCalculated(r)?.materialWidth

        return (
            <ShipmentCalculatedValue isActual={isShipmentCalculatedOnActual(r)}>
                {width}
            </ShipmentCalculatedValue>
        )
    },
}
